<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Usuario"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-3">
            <label>Rol</label>
            <p-dropdown
              formControlName="roleId"
              [options]="roles"
              optionLabel="name"
              optionValue="id"
            ></p-dropdown>
          </div>
          <div class="field col-12 md:col-9"></div>
          <div class="field col-12 md:col-6">
            <label>Nombres</label>
            <input pInputText formControlName="names" type="text" />
            <div
              *ngIf="
                fg.get('names').invalid &&
                (fg.get('names').dirty || fg.get('names').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('names').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('names').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('names').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label>Apellidos</label>
            <input pInputText formControlName="surnames" type="text" />
            <div
              *ngIf="
                fg.get('surnames').invalid &&
                (fg.get('surnames').dirty || fg.get('surnames').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('surnames').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('surnames').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('surnames').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label>Usuario</label>
            <input pInputText formControlName="username" type="text" />
            <div
              *ngIf="
                fg.get('username').invalid &&
                (fg.get('username').dirty || fg.get('username').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('username').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('username').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('username').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="row mb-3">
              <label>Restablecer Contraseña</label>
            </div>
            <div class="row ml-3">
              <p-inputSwitch
                (click)="checkRestart()"
                formControlName="restartPassword"
              ></p-inputSwitch>
            </div>
          </div>
          <p-message
            *ngIf="restartPassword"
            severity="info"
            text='Al marcar restablecer contraseña, el usuario podrá cambiar su contraseña al ingresar nuevamente al sistema. La contraseña será igual al campo "Usuario". Por ejemplo, si el usuario es "vendedor" la contraseña será "vendedor"'
            styleClass="p-mr-2"
          ></p-message>
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="fg.invalid || !this.changeForm"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
